export let RuntimeMediaQuery = /*#__PURE__*/function (RuntimeMediaQuery) {
  RuntimeMediaQuery["COMMON"] = "common";
  RuntimeMediaQuery["DESKTOP"] = "desktop";
  RuntimeMediaQuery["TABLET"] = "tablet";
  RuntimeMediaQuery["TABLET_IMPLICIT"] = "tablet_implicit";
  RuntimeMediaQuery["MOBILE"] = "mobile";
  RuntimeMediaQuery["MOBILE_IMPLICIT"] = "mobile_implicit";
  return RuntimeMediaQuery;
}({});
//# sourceMappingURL=RuntimeMediaQuery.js.map